import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function urlValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value || value === 'https://') {
            return null;
        }
        const urlPattern = /^https?:\/\/[a-zA-Z0-9][a-zA-Z0-9-]*\.[a-zA-Z0-9-.]+[a-zA-Z](\/[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=%]*)?$/;
        if (!urlPattern.test(value)) {
            return {invalidUrl: true};
        }
        return null;
    };
}
